import React, { Component } from "react";
import { Grid } from "@mui/material";
import { connect } from "react-redux";
import {
  moveToDeleteAccountPage,
  moveToMainPage,
  moveToResetPasswordPage,
} from "../actions/routeactions";

class OptionsPage extends Component {
  constructor(props) {
    super(props);

    this.resetPassword = this.resetPassword.bind(this);
    this.deleteAccount = this.deleteAccount.bind(this);
    this.back = this.back.bind(this);
  }

  resetPassword() {
    const { dispatch } = this.props;
    dispatch(moveToResetPasswordPage());
  }

  back() {
    const { dispatch } = this.props;
    dispatch(moveToMainPage(false));
  }

  deleteAccount() {
    const { dispatch } = this.props;
    dispatch(moveToDeleteAccountPage());
  }

  render() {
    return (
      <Grid container alignItems="center" justifyContent="center">
        <div className="form login_form">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <h2>Options</h2>
            </Grid>
            <Grid item xs={12}>
              <button className="bbe-button" onClick={this.resetPassword}>
                Reset Password
              </button>
            </Grid>
            <Grid item xs={12}>
              <button className="bbe-button" onClick={this.deleteAccount}>
                Delete Account
              </button>
            </Grid>
            <Grid item xs={12}>
              <p className="hyperlink" onClick={this.back}>
                <u>Back To Band Details</u>
              </p>
            </Grid>
          </Grid>
        </div>
      </Grid>
    );
  }
}

export default connect()(OptionsPage);
